import { useEffect, useState} from 'react';
import axios from 'axios';
import './Header.css';
import { Link,useLocation } from 'react-router-dom';
import { CartUpdateService } from '../../../services/CartUpdateService'; // Import the CartUpdateService
import passLogo from '../../../assets/images/passLogo.png';
import { CART_BASE_URL } from '../../../config/ApiConfig';

export const Header = () => {
    const [price, setPrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [cartItems, setCartItems] = useState(() => {
        const savedCart = sessionStorage.getItem('wa_crt_itms');
        return savedCart ? JSON.parse(savedCart) : [];
    });
    const [ ordersData,setOrdersData] = useState([]);
    const [cartGUID, setCartGUID] = useState(sessionStorage.getItem('wa_crt_cid') || null);
    const location = useLocation();
    useEffect(() => {
        // Check if we are coming back from OrderSummary
        if (location.state?.isOrderCompleted) {
            // Reset the cart state when coming back from OrderSummary
            setQuantity(0);
            setPrice(0);
            setOrdersData([]);
        }
    }, [location]);
    const loadData = async (cartGUID) => {
        // Check if cartGUID is valid
        if (!cartGUID) return;
        try{
            const response = await axios.get(`${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`);
            const orderDetails = response.data.data.cartDetails.passes;
            setOrdersData(orderDetails);
        }catch(error){
            console.log(error.response);
        }
        
    };
    // Effect for polling sessionStorage and updating cartItems
    useEffect(() => {
        const intervalId = setInterval(() => {
            const savedCart = sessionStorage.getItem('wa_crt_itms');
            const parsedCart = savedCart ? JSON.parse(savedCart) : [];
            const id = sessionStorage.getItem('wa_crt_cid');
            // Only update cartItems if it has changed
            if (JSON.stringify(cartItems) !== JSON.stringify(parsedCart)) {
                setCartItems(parsedCart);
            }
            if (id && id !== cartGUID) {
                setCartGUID(id);
            }
        }, 0); 
        return () => clearInterval(intervalId); 
    }, [cartItems, cartGUID]); 
    // Subscribe to the cart update events
    useEffect(() => {
        if(cartGUID){
            loadData(cartGUID);
        }
        const subscription = CartUpdateService.cartUpdated.subscribe((data) => {
            
            // Call loadData when cart is updated
            if (cartGUID) {
                loadData(cartGUID); 
            }
        });
        // Cleanup the subscription on unmount
        return () => subscription.unsubscribe();
    }, [cartGUID]);
    // Recalculate price and quantity when cartItems changes
    const calculateTotals = () => {
        if (ordersData && ordersData.length > 0) {
            
            const totalQuantity = ordersData.reduce((total, item) => total + item.quantity, 0);
            setQuantity(totalQuantity);
            const totalCost = ordersData.reduce((total, item) => {
                const itemPrice = item.price || item.perUnitPrice;
                return total + (itemPrice + item.processingFee) * item.quantity;
            }, 0);
            setPrice(totalCost);

        }else{

            const totalQuantity = cartItems.reduce((total, item) => total + item.quantity, 0);
            setQuantity(totalQuantity);

            const totalCost = cartItems.reduce((total, item) => {
                const itemPrice = item.price || item.perUnitPrice;
                return total + (itemPrice + item.processingFee) * item.quantity;
            }, 0);
            setPrice(totalCost);
        }
    };
    useEffect(() => {
        calculateTotals();
    }, [cartItems,ordersData]); 
    // Check if the current route matches "/orders/generated-passes/:OrderGUID"
    const isOnGeneratedPassesPage = location.pathname.startsWith('/orders/generated-passes');
    return (
        <>
            <header className="navBG">
                <Link to='/' className='logoTop'>
                    <img src={passLogo} alt="imageLogo" className="img-fluid"></img>
                </Link>
                <div className=" headerLinks">
                    <nav className={`d-flex justify-content-end align-items-center  ${isOnGeneratedPassesPage ? 'd-none' : ''}`}>
                        <div className="navLinks-wrapper">
                            <div className="navLinks d-flex py-3">
                                <Link to={`/shop/annual-pass`} state={{ passID: 1,passGUID:"d15aa8d6-fc0a-461d-98d0-27c245b627cc" }} className='nav-link text-light px-1'>Annual Pass</Link>
                                <Link to={`/shop/one-day-pass`} state={{ passID: 2,passGUID:"06b5b7eb-3ad2-4931-8850-3baad86ef2be" }} className='nav-link text-light px-1'>One-Day Pass</Link>
                                <Link to={`/cart`} className="nav-link text-light px-1">Checkout</Link>
                            </div>
                        </div>    
                        <div className="cart py-3">
                            <div className='border-start ps-3 cart-price'>
                                <span className="fw-bold">{quantity}</span> passes / $
                                <span className="fw-bold">{price.toFixed(2)}</span>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            <div className="photoBG bg-start"></div>
        </>
    );
};